import React, { useState, useEffect } from 'react';
import {
    Title,
    Button
} from '@bsf/force-ui';
import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';

const TemplateSection = () => {
    
	const [loading, setLoading] = useState(true);
	const [templatesStatus, setTemplatesStatus] = useState(null); 
    const [redirectUrl, setRedirectUrl] = useState(null); 

    useEffect(() => {
        const fetchSettings = () => {
            setLoading(true);
            apiFetch({
                path: '/uael/v1/templates',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': uaelSettingsData.uael_nonce_action, // Use the correct nonce
                },
            })
                .then((data) => {
                    setTemplatesStatus(data.templates_status);
                    if (data.redirect_url) {
                        setRedirectUrl(data.redirect_url); // Save URL in state variable
                    }
                    setLoading(false); // Stop loading
                })
                .catch((err) => {
                    setLoading(false); // Stop loading
                });
        };

        fetchSettings();
    }, []);

    const handleButtonClick = (e) => {
        if( 'Activated' === templatesStatus && redirectUrl ) {
            window.open( redirectUrl, '_blank' );
        }
    };

	if( loading ) {
		return;
	}

    return (
        <div className="box-border hfe-dashboard-templates p-4 bg-white rounded-lg shadow-md mb-6 uae-subheading">
            <div className="mb-4">
                <img
                    src={`${uaelSettingsData.templates_url}`}
                    alt="Template Showcase"
                    className="w-full h-auto rounded"
                />
            </div>
            <Title
                className="mt-2"
                icon={null}
                iconPosition="right"
                size="xs"
                tag="h2"
                title={__('Build Websites 10x Faster with Templates', 'uael')}
            />
            <p className='text-text-secondary mt-2 mb-2 text-sm'>{__('Choose from our professionally designed websites to build your site faster, with easy customization options.', 'uael')}</p>
                    <Button
                        className="w-full mt-4"
                        icon={null}
                        iconPosition="left"
                        size="md"
                        variant="secondary"
                        // onClick={handleButtonClick}
                        onClick={() => {
							window.open(
								"https://startertemplates.com/",
								"_blank"
							);
						}}
                    >
                        {__('Explore Templates', 'uael')}
                    </Button>
        </div>
    );
};

export default TemplateSection;